
import Establishment from './establishment.vue'
export default {
  components: {Establishment},
  props: {
    education: {type: Array, required: true}
  },
  computed: {
    split_index(){
      return Math.ceil(this.education.length / 2)
    },
    first_col(){
      return this.education.slice(0, this.split_index)
    },
    second_col(){
      return this.education.slice(this.split_index)
    }
  },
}
